import React, { useEffect, useState } from 'react'
import { Modal, ModalId, useUIActions, useUIState } from "../../../ui"
import { Data2 } from '../../types'

type Props = {
    title?: string
    children: JSX.Element
    widthSize?: 's' | 'm' | 'l'
}

export const QuickFormModal = (props: Props) => {
    const { title, children, widthSize } = props
    
    const [key, setKey] = useState(0)
    
    const { openedModal } = useUIState()

    const { closeModal } = useUIActions()

    useEffect(() => setKey(key + 1), [openedModal])

    const onSubmit = (data: Data2) => {
        children.props.onSubmit(data)
        closeModal(ModalId.QUICK_FORM)
    }

    const onCancel = () => {
        closeModal(ModalId.QUICK_FORM)
    }

    return (
        <Modal
            modalId={ModalId.QUICK_FORM}
            title={title || 'Crear Nuevo'}
            actions={[]}
            widthSize={widthSize}
        >
            {React.cloneElement(children, {
                key,
                onSubmit,
                onCancel
            })}
        </Modal>
    )
}
